import React from "react";
import clx from "classnames";

interface Props {
    children: React.ReactNode;
    className?: string;
    hideBorder?: boolean;
}

const TableRow = ({ children, hideBorder, className }: Props) => {
    const cn = clx(
        {
            "border-b border-gray-200 last:border-none ": !hideBorder,
        },
        className
    );

    return <tr className={cn}>{children}</tr>;
};

export default TableRow;
